import { render, staticRenderFns } from "./Examples.vue?vue&type=template&id=0c30af5d&lang=pug&"
import script from "./Examples.vue?vue&type=script&lang=js&"
export * from "./Examples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c30af5d')) {
      api.createRecord('0c30af5d', component.options)
    } else {
      api.reload('0c30af5d', component.options)
    }
    module.hot.accept("./Examples.vue?vue&type=template&id=0c30af5d&lang=pug&", function () {
      api.rerender('0c30af5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/Examples.vue"
export default component.exports